
import { Component, Inject, Vue } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import { Logout } from '@/views';

@Component({})
export default class MainLayout extends Vue {
    @Inject(Service) service!: Services;
    @Inject(Navigator) navigator!: Navigation;

    drawer = false;

    menuItems = [
        { title: '考试管理', route: '/manage/exam', icon: 'mdi-school' },
        { title: '专家打款', route: '/manage/payment', icon: 'mdi-cash-multiple' },
    ];

    get isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    get currentSelection() {
        return this.navigator.currentPath;
    }

    created() {
        this.drawer = !this.isMobile;
    }

    navigateTo(route: string) {
        if (this.isMobile) {
            this.drawer = false;
        }
        this.$router.push(route).catch(() => {});
    }

    public logout(): void {
        this.navigator.redirectTo(Logout);
    }
}
